/*
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-19 11:29:32
 * @Reference:
 */
export default {
  className: 'keyWordShild',
  fields: [
    {
      name: 'keyWord',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    }
  ],
  search: [
    'keyWord'
  ],
  action: {
    export: false
  }
}
